export default "__VITE_ASSET__CDMK7Phy__"